import firebase from 'firebase/compat/app';
import "firebase/compat/auth";
import "firebase/compat/analytics";
import "firebase/compat/firestore";
import "firebase/compat/performance";

const config = {
  apiKey: "AIzaSyB6I-vnhh429lbL055gZEwDdzi7r-o1HVs",
  authDomain: "elearning-test-fc3ce.firebaseapp.com",
  databaseURL: "https://elearning-test-fc3ce.firebaseio.com",
  projectId: "elearning-test-fc3ce",
  storageBucket: "elearning-test-fc3ce.appspot.com",
  messagingSenderId: "1088209020260",
  appId: "1:1088209020260:web:96e4d5073dd93f8ca4c671",
  measurementId: "G-58D0KK0KGQ",
};
export default firebase.initializeApp(config);
